import { render } from "./ChatsIaContent.vue?vue&type=template&id=1a6e5e90&ts=true"
import script from "./ChatsIaContent.vue?vue&type=script&lang=ts"
export * from "./ChatsIaContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__